var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, ViewChild } from '@angular/core';
import { Platform, Nav, Events, IonicApp, AlertController } from 'ionic-angular';
import { ApiProvider } from '../providers/api/api';
import { AnalyticsProvider } from '../providers/analytics/analytics';
import { CommonProvider } from '../providers/common/common';
import { Storage } from '@ionic/storage';
import { FirebaseMessagingProvider } from '../providers/firebase-messaging/firebase-messaging';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
var MyApp = /** @class */ (function () {
    function MyApp(platform, events, ionicApp, apiProv, gaProv, comProv, storage, fcmProv, alertCtrl, translate) {
        var _this = this;
        this.platform = platform;
        this.events = events;
        this.ionicApp = ionicApp;
        this.apiProv = apiProv;
        this.gaProv = gaProv;
        this.comProv = comProv;
        this.storage = storage;
        this.fcmProv = fcmProv;
        this.alertCtrl = alertCtrl;
        this.translate = translate;
        this.menu_header = { background_color: '', image: '', title: '' };
        this.service_data = [];
        this.user_data = [];
        this.is_login = false;
        this.drawer_list = [];
        this.is_pwa_account = false;
        this.button_color = '#ffffff';
        this.button_background = '#4e8ef7';
        this.rootParams = [];
        this.chk_start = { chk_home: false, chk_slide: false, chk_token: false, chk_rss: false, chk_drawer: false, shop_info: false };
        this.chk_pc = { chk_drawer: false, chk_push: false, chk_event: false, chk_coupon: false, chk_menu: false };
        this.add_langs = ['ja', 'en'];
        if (location.hash == '#/home') {
            this.comProv.restart();
        }
        platform.ready().then(function () {
            _this.is_pc = _this.comProv.isPc();
            _this.setupBackButtonBehavior();
        });
        this.url = new URL(window.location.href);
        this.params = this.url.searchParams;
        if (this.params.get('back') == 1) {
            var user_agent = window.navigator.userAgent;
            if (user_agent.indexOf('tenpoapp ServiceId') != -1) {
                var back_url = window.location.href;
                back_url = back_url.replace(/back=1/g, 'back=2');
                this.comProv.closeWebview(back_url);
                return;
            }
        }
        // プレビュー表示
        if (this.params.get('page') == 'PreviewPage') {
            this.comProv.setOptions('is_preview', 1);
            this.comProv.restart();
        }
        // 多言語設定
        this.translate.setDefaultLang('ja');
        this.translate.addLangs(this.add_langs);
        this.rootParams['is_top_tab_list'] = false;
        var app_version = this.params.get('app_version');
        if (app_version) {
            this.comProv.getAppUid();
            this.comProv.getAppToken();
            this.comProv.getAppUser();
            localStorage.setItem('is_app', '1');
            localStorage.setItem('app_version', app_version);
            this.app_version = app_version;
            // 会員証番号
            this.comProv.setMemberBarcode();
        }
        this.is_app = this.comProv.isApp();
        if (this.params.get('page') == 'MemberSafePage' || location.hash == '#/member-safe') {
            this.rootPage = 'MemberSafePage';
            return;
        }
        try {
            google;
        }
        catch (e) {
            this.setGoogleMap();
        }
        this.getService();
        events.subscribe('login:set', function () {
            _this.is_login = _this.comProv.isLogin();
        });
        window.appUid = function (uid) {
            this.app_uid = uid;
        }.bind(this);
        window.appToken = function (token) {
            this.app_token = token;
        }.bind(this);
        window.appUserAuthenticates = function (user_authenticate) {
            this.app_user_authenticate = decodeURIComponent(user_authenticate);
        }.bind(this);
        window.appQRCodeReader2 = function (value) {
            this.goQRCodeUrl(value);
        }.bind(this);
        window.appMemberCode = function (member_code) {
            var user_data = this.comProv.getUser();
            user_data['member_code'] = member_code;
            this.comProv.setUser(user_data);
        }.bind(this);
        window.appPoint = function (point) {
            var point_data = {};
            point_data['point'] = point;
            point_data['get_time'] = this.comProv.formatDate(new Date(), 'YYYY/MM/DD hh:mm:ss');
            localStorage.setItem('point_data', JSON.stringify(point_data));
            this.events.publish('point_data');
        }.bind(this);
    }
    MyApp.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.nav.viewDidLoad.subscribe(function (view) {
            //this.nav.viewDidEnter.subscribe((view) => {
            _this.current_page = view.instance.constructor.name;
            _this.rootParams['current_page'] = view.instance.constructor.name;
            if (_this.current_page == 'ErrorPage' ||
                _this.current_page == 'PrivacyPage' ||
                _this.current_page == 'SharePage' ||
                _this.current_page == 'EventSitePage' ||
                _this.current_page == 'MemberSafePage') {
                return;
            }
            _this.checkPlatform();
        });
    };
    MyApp.prototype.setupBackButtonBehavior = function () {
        var _this = this;
        if (window.location.protocol !== "file:") {
            window.onpopstate = function (evt) {
                var activePortal = _this.ionicApp._loadingPortal.getActive() ||
                    _this.ionicApp._modalPortal.getActive() ||
                    _this.ionicApp._toastPortal.getActive() ||
                    _this.ionicApp._overlayPortal.getActive();
                if (activePortal) {
                    try {
                        activePortal.dismiss();
                    }
                    catch (e) {
                        console.log(e);
                    }
                    return;
                }
            };
        }
    };
    MyApp.prototype.setGoogleMap = function () {
        var googlemap_key = 'AIzaSyDg9cLhXb7UBK6tFw7d-2Lqib-59X1ZtQQ';
        var key_list = [
            { name: 'S1-100', min: 1, max: 100, keys: ['AIzaSyDg9cLhXb7UBK6tFw7d-2Lqib-59X1ZtQQ'] },
            { name: 'S101-300', min: 101, max: 300, keys: ['AIzaSyBIW5X1dsWtTu0DfDmbuo_NskQGcAjxE7k'] },
            { name: 'S301-400', min: 301, max: 400, keys: ['AIzaSyD3P1N2leLpKupDQKOJvyTVFF6svipQIi8'] },
            { name: 'S401-500', min: 401, max: 500, keys: ['AIzaSyClNMVhSEolNKOJV4goFx3qa0jjvATOVIA'] },
            { name: 'S501-600', min: 501, max: 600, keys: ['AIzaSyDMChpm09JGD2zrMD4yIcTVmGTAILAGLvc'] }
        ];
        var find_data = key_list.find(function (value) {
            return (SERVICE_ID >= value['min'] && SERVICE_ID <= value['max']);
        });
        if (find_data) {
            if (find_data['keys'].length > 1) {
                googlemap_key = find_data['keys'][Math.floor(Math.random() * find_data['keys'].length)];
            }
            else {
                googlemap_key = find_data['keys'][0];
            }
        }
        //console.log('googlemap_key', googlemap_key);
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = 'https://maps.google.com/maps/api/js?key=' + googlemap_key;
        document.body.appendChild(script);
    };
    MyApp.prototype.getService = function () {
        var _this = this;
        var url_req;
        if (this.url['hostname'] == 'localhost') {
            url_req = API_ENDPOINT + '/api/services/' + SERVICE_ID;
        }
        else {
            //url_req = API_ENDPOINT + '/api/services/' + SERVICE_ID;
            url_req = '/api/services/' + SERVICE_ID;
        }
        this.apiProv.dispLoader();
        this.apiProv.get(url_req)
            .then(function (data) {
            if (data['statusCode'] != '000') {
                _this.apiProv.removeLoader();
                _this.goError('通信環境の良い場所で再度起動してください。');
                return;
            }
            else {
                _this.service_data = data['data'];
                localStorage.setItem('service_data', JSON.stringify(_this.service_data));
                _this.is_pwa_account = _this.comProv.isPwaAccount();
                _this.fcmProv.start();
                // 多言語設定
                if (_this.service_data['option']['is_multilingual']) {
                    var browser_lang = _this.translate.getBrowserLang();
                    if (_this.add_langs.indexOf(browser_lang) >= 0) {
                        _this.translate.use(browser_lang);
                    }
                }
                if (_this.service_data['status'] != 1) {
                    _this.apiProv.removeLoader();
                    _this.goError('現在サービスはご利用できません。');
                    return;
                }
                if (location.hash == '#/share' || location.hash == '#/privacy') {
                    _this.apiProv.removeLoader();
                    _this.getHome();
                    return;
                }
                _this.checkPlatform();
                if (!_this.is_app && _this.url['hostname'] != 'localhost') {
                    if (_this.service_data['pwa_url'].indexOf(_this.url['host']) == -1) {
                        // 独自ドメインにリダイレクト
                        window.location.href = _this.service_data['pwa_url'];
                    }
                }
                if (_this.service_data['ga4_tracking_id']) {
                    try {
                        gtag('config', _this.service_data['ga4_tracking_id']);
                    }
                    catch (e) {
                        console.log(e);
                    }
                    _this.nav.viewDidEnter.subscribe(function (view) {
                        _this.gaProv.trackViewGA4(view.id);
                    });
                }
                // トップページ
                _this.getHome();
                _this.getDrawer();
                _this.getSlide();
                if (_this.comProv.isPc()) {
                    _this.getPush();
                    _this.getEvent();
                    _this.getCoupon();
                    _this.getMenuAll();
                    _this.chk_start['chk_rss'] = true;
                }
                // 共通部品取得
                _this.getPhotoCategory();
                _this.getCouponCategory();
                _this.getShopInfo();
                /*if (this.service_data['is_app_membership_card']) {
                  this.getCardData();
                }*/
                if (!_this.comProv.isPc()) {
                    _this.getWebviewData();
                    _this.getProfileList();
                    if (_this.service_data['option']['is_rss_feed']) {
                        _this.getRssList();
                    }
                    else {
                        _this.chk_start['chk_rss'] = true;
                    }
                }
                if (_this.service_data['font']) {
                    var font = _this.service_data['font'];
                    var style = document.createElement('style');
                    style.textContent = "@font-face {font-family:'" + font + "';}ion-content{font-family:'" + font + "';}ion-header{font-family:'" + font + "';}ion-footer{font-family:'" + font + "';}";
                    document.head.appendChild(style);
                }
                // ユーザー取得
                _this.getUid();
            }
        }).catch(function (error) {
            _this.apiProv.removeLoader();
            var message = _this.apiProv.getErrorMessage(error, '通信環境の良い場所で再度起動してください。');
            _this.goError(message);
        });
    };
    MyApp.prototype.checkPlatform = function () {
        if (this.params.get('page') == 'EventSitePage' || location.hash.indexOf('#/event-site') === 0) {
            return;
        }
        var service_data = this.comProv.getService();
        if (this.is_app) {
            if (this.platform.is('ios')) {
                if (service_data['is_ios_app'] != 1) {
                    this.goError('現在iOSアプリはご利用できません。');
                }
            }
            if (this.platform.is('android')) {
                if (service_data['is_android_app'] != 1) {
                    this.goError('現在アンドロイドアプリはご利用できません。');
                }
            }
        }
        else {
            if (this.comProv.isPc()) {
                if (service_data['is_pc'] != 1) {
                    this.goError('現在PCはご利用できません。');
                }
            }
            else {
                if (service_data['is_pwa'] != 1) {
                    this.goError('現在PWAはご利用できません。');
                }
            }
        }
    };
    MyApp.prototype.getHome = function () {
        var _this = this;
        this.apiProv.get(this.service_data['_links']['app_top_menu']['href'])
            .then(function (data) {
            if (data['statusCode'] != '000') {
                _this.goError('トップメニューの設定を行ってください。');
                return;
            }
            // プレビュー表示
            if (_this.comProv.getOptionsValue('is_preview')) {
                if (!data['data']['preview_body']) {
                    _this.comProv.setOptions('is_preview', 0);
                    _this.goError('プレビュー表示設定がありません。');
                    return;
                }
                data['data']['base'] = data['data']['preview_base'];
                data['data']['header'] = data['data']['preview_header'];
                data['data']['body'] = data['data']['preview_body'];
                data['data']['footer'] = data['data']['preview_footer'];
            }
            _this.comProv.setHomeImage(data['data']['body']);
            localStorage.setItem('header_data', JSON.stringify(data['data']['header']));
            _this.setFooter(data['data']['footer']);
            localStorage.setItem('pc_data', JSON.stringify(data['data']['pc']));
            localStorage.setItem('words_data', JSON.stringify(data['data']['words']));
            if ('images' in data['data']) {
                localStorage.setItem('images_data', JSON.stringify(data['data']['images']));
            }
            else {
                localStorage.removeItem('images_data');
            }
            var base_data = data['data']['base'];
            localStorage.setItem('base_data', JSON.stringify(base_data));
            if (base_data['button_color']) {
                _this.button_color = base_data['button_color'];
            }
            if (base_data['button_background_color']) {
                _this.button_background = base_data['button_background_color'];
            }
            _this.setMenuHeader(data['data']['header']);
            if (location.hash == '#/share' || location.hash == '#/privacy') {
                _this.events.publish('share:start');
            }
            else {
                _this.chk_start['chk_home'] = true;
                _this.goHome();
            }
        }).catch(function (error) {
            var message = _this.apiProv.getErrorMessage(error, 'トップメニューの設定を行ってください。');
            _this.goError(message);
        });
    };
    MyApp.prototype.setFooter = function (footer_data) {
        if (!footer_data || footer_data == '') {
            return;
        }
        var set = [];
        for (var i = 1; i <= 5; i++) {
            var line = {
                icon: footer_data['tab_icon' + i],
                text: footer_data['tab_text' + i],
                target: footer_data['tab_target' + i],
                url: footer_data['tab_url' + i]
            };
            if (!line['icon'] || !line['text'] || !line['target']) {
                continue;
            }
            set.push(line);
        }
        localStorage.setItem('footer_list', JSON.stringify(set));
        localStorage.setItem('footer_color', footer_data['color']);
        localStorage.setItem('footer_inactive_color', footer_data['inactive_color'] ? footer_data['inactive_color'] : '#b3b3b3');
        localStorage.setItem('footer_background_color', footer_data['background_color']);
    };
    MyApp.prototype.setMenuHeader = function (header_data) {
        this.menu_header['title'] = this.service_data['name'];
        if (header_data && header_data != '') {
            this.menu_header['background_color'] = header_data['background_color'];
            this.menu_header['image'] = header_data['image'];
        }
    };
    MyApp.prototype.getSlide = function () {
        var _this = this;
        this.apiProv.get(this.service_data['_links']['app_top_slide_images']['href'])
            .then(function (data) {
            if (data['statusCode'] != '000') {
                return;
            }
            _this.rootParams['slide_list'] = data['data'];
            _this.chk_start['chk_slide'] = true;
            _this.goHome();
        }).catch(function (error) {
        });
    };
    MyApp.prototype.getPush = function () {
        var _this = this;
        this.apiProv.get(this.service_data['_links']['notifications']['href'])
            .then(function (data) {
            if (data['statusCode'] != '000') {
                return;
            }
            _this.rootParams['push_list'] = data['data'];
            _this.chk_pc['chk_push'] = true;
            _this.goHomePc();
        }).catch(function (error) {
            _this.chk_pc['chk_push'] = true;
            _this.goHomePc();
        });
    };
    MyApp.prototype.getEvent = function () {
        var _this = this;
        this.apiProv.get(this.service_data['_links']['events']['href'])
            .then(function (data) {
            if (data['statusCode'] != '000') {
                return;
            }
            _this.rootParams['event_list'] = data['data'];
            _this.chk_pc['chk_event'] = true;
            _this.goHomePc();
        }).catch(function (error) {
            _this.chk_pc['chk_event'] = true;
            _this.goHomePc();
        });
    };
    MyApp.prototype.getCoupon = function () {
        var _this = this;
        this.apiProv.get(this.service_data['_links']['coupons']['href'])
            .then(function (data) {
            if (data['statusCode'] != '000') {
                return;
            }
            var coupon_list = data['data'].filter(function (item) {
                return (item['type'] != 2);
            }, _this);
            localStorage.setItem('coupon_list', JSON.stringify(coupon_list));
            _this.rootParams['coupon_list'] = coupon_list;
            _this.chk_pc['chk_coupon'] = true;
            _this.goHomePc();
        }).catch(function (error) {
            _this.chk_pc['chk_coupon'] = true;
            _this.goHomePc();
        });
    };
    MyApp.prototype.getMenuAll = function () {
        var _this = this;
        this.apiProv.get(this.service_data['_links']['menu_all']['href'])
            .then(function (data) {
            if (data['statusCode'] != '000') {
                return;
            }
            _this.rootParams['menu_all'] = data['data'];
            _this.chk_pc['chk_menu'] = true;
            _this.goHomePc();
        }).catch(function (error) {
            _this.chk_pc['chk_menu'] = true;
            _this.goHomePc();
        });
    };
    MyApp.prototype.goHome = function () {
        if (!this.chk_start['chk_home'] || !this.chk_start['chk_slide'] || !this.chk_start['chk_token'] || !this.chk_start['chk_rss'] || !this.chk_start['chk_drawer'] || !this.chk_start['shop_info']) {
            return;
        }
        this.apiProv.removeLoader();
        this.rootParams['is_start'] = true;
        var top_flg = this.comProv.checkTop();
        if (!this.uid || this.comProv.isPc()) {
            top_flg = false;
        }
        if (top_flg) {
            if (this.comProv.isTutorial()) {
                this.rootPage = 'TopTutorialPage';
            }
            else {
                this.rootPage = 'TopRulePage';
            }
        }
        else {
            if (!location.hash) {
                var page = this.params.get('page');
                var is_tab_start = false;
                if (!this.comProv.isPc()) {
                    is_tab_start = this.comProv.checkTabStart();
                }
                console.log('is_tab_start', is_tab_start);
                if (page) {
                    if (page == 'CouponIndexPage' && this.params.get('target')) {
                        this.comProv.setOptions('private_coupon_target', this.params.get('target'));
                        history.replaceState('', '', '/');
                    }
                    else if (page == 'EventSitePage' && this.params.get('shop_id')) {
                        this.nav.setRoot('EventSitePage', { shop_id: this.params.get('shop_id'), site_flg: 1 });
                        history.replaceState('', '', '/');
                        return;
                    }
                    this.rootPage = page;
                }
                else if (is_tab_start) {
                    // タブベージ起動
                    var tab_start = this.comProv.getStorageData('tab_start');
                    var targets = tab_start['page_target'].split('-');
                    var shop_id = 0;
                    if (tab_start['top_tab_shop_id']) {
                        shop_id = tab_start['top_tab_shop_id'];
                    }
                    this.nav.setRoot(targets[0], { free_id: targets[1], shop_id: shop_id });
                }
                else {
                    this.rootPage = 'home';
                }
            }
            else if (location.hash == '#/home') {
                this.rootPage = 'home';
            }
        }
    };
    MyApp.prototype.goHomePc = function () {
        if (!this.chk_pc['chk_drawer'] || !this.chk_pc['chk_push'] || !this.chk_pc['chk_event'] || !this.chk_pc['chk_coupon'] || !this.chk_pc['chk_menu']) {
            return;
        }
        this.rootParams['is_pc_start'] = true;
        this.events.publish('home:pc');
    };
    MyApp.prototype.getUid = function () {
        var _this = this;
        if (this.comProv.isPc()) {
            this.chk_start['chk_token'] = true;
            this.goHome();
            return;
        }
        if (this.is_app) {
            if (!this.app_uid || this.app_uid == '' || this.app_uid == 'null') {
                new Image().src = '?app_log=notUid1';
                // 2秒遅延
                this.comProv.getAppUid();
                setTimeout(function () {
                    if (!_this.app_uid || _this.app_uid == '' || _this.app_uid == 'null') {
                        new Image().src = '?app_log=notUid2';
                        _this.goError('UIDが取得できません。');
                        return;
                    }
                    _this.uid = _this.app_uid;
                    //this.uid = app_uid_val;
                    _this.getAppToken();
                    //this.getToken();
                }, 2000);
            }
            else {
                this.uid = this.app_uid;
                //this.uid = app_uid_val;
                this.getAppToken();
                //this.getToken();
            }
        }
        else {
            this.storage.get('uid').then(function (val) {
                if (!val || val == '' || val == 'null') {
                    _this.chk_start['chk_token'] = true;
                    _this.goHome();
                    return;
                }
                _this.uid = val;
                _this.getToken();
            });
        }
    };
    MyApp.prototype.getAppToken = function () {
        // アプリからデータが取得できない場合
        if (!this.app_token || !this.app_user_authenticate) {
            new Image().src = '?getLocalToken=ng&code=NotGetFromApp&time=' + new Date().getTime();
            this.getToken();
            return;
        }
        if (this.comProv.isAndroid()) {
            var app_version = this.comProv.getAppVersion();
            if (app_version && app_version < 1.21) {
                new Image().src = '?getLocalToken=ng&code=NotAndroidVersion&app_version=' + app_version + '&time=' + +new Date().getTime();
                this.getToken();
                return;
            }
        }
        var local_token = localStorage.getItem('token');
        ;
        var local_user_data = this.comProv.getUser();
        var tmp_app_user = JSON.parse(this.app_user_authenticate);
        var app_user_data = tmp_app_user['data'];
        var use_local_data = false;
        if (local_token && local_user_data['id'] && local_user_data['id'] != 'undefined') {
            // ローカルの方が新しい
            var chk_token_time = this.comProv.checkTime(app_user_data['accessed_at'], local_user_data['accessed_at']);
            if (chk_token_time) {
                use_local_data = true;
            }
        }
        if (use_local_data) {
            new Image().src = '?getLocalToken=ok&data=local&local_accessed_at=' + local_user_data['accessed_at'] + '&app_accessed_at=' + app_user_data['accessed_at'] + '&time=' + new Date().getTime();
            this.user_data = local_user_data;
        }
        else {
            new Image().src = '?getLocalToken=ok&data=app&local_accessed_at=' + local_user_data['accessed_at'] + '&app_accessed_at=' + app_user_data['accessed_at'] + '&time=' + new Date().getTime();
            this.user_data = app_user_data;
            this.comProv.setUser(this.user_data);
            this.storage.set('uid', this.user_data['uid']);
            localStorage.setItem('token', this.app_token);
        }
        this.is_login = this.comProv.isLogin();
        this.setGatagUserId();
        this.setFcmToken();
        this.chk_start['chk_token'] = true;
        this.goHome();
    };
    MyApp.prototype.getToken = function () {
        var _this = this;
        console.log('getToken app.component.ts');
        var user_env = [];
        user_env['uid'] = this.uid;
        this.comProv.setUserEnv(user_env);
        this.apiProv.post(this.service_data['_links']['user_authenticate']['href'], user_env)
            .then(function (data) {
            if (data['statusCode'] != '000') {
                if (_this.is_app) {
                    _this.goError('アプリのUIDが正しくありません。');
                }
                else {
                    _this.goError('該当ユーザが見つかりません。');
                }
            }
            else {
                _this.user_data = data['data'];
                _this.comProv.setUser(_this.user_data);
                _this.storage.set('uid', _this.user_data['uid']);
                localStorage.setItem('token', data['token']);
                _this.is_login = _this.comProv.isLogin();
                _this.setGatagUserId();
                _this.setFcmToken();
                _this.chk_start['chk_token'] = true;
                _this.goHome();
            }
        }).catch(function (error) {
            console.log('user_authenticate', error);
            if (_this.is_app) {
                var message = _this.apiProv.getErrorMessage(error, 'アプリのUIDが正しくありません。');
                _this.goError(message);
            }
            else {
                if (error['status'] == 404) {
                    _this.comProv.logout();
                }
                var message = _this.apiProv.getErrorMessage(error, '該当ユーザが見つかりません。');
                _this.goError(message);
            }
        });
    };
    MyApp.prototype.setGatagUserId = function () {
        if (!this.service_data['ga4_tracking_id']) {
            return;
        }
        if (!this.is_login) {
            return;
        }
        try {
            gtag('set', 'user_id', this.user_data['id']);
            console.log('gtag user_id', this.user_data['id']);
        }
        catch (e) {
            console.log(e);
        }
    };
    MyApp.prototype.setFcmToken = function () {
        var _this = this;
        if (this.is_app) {
            return;
        }
        this.storage.get('fcm_token').then(function (val) {
            if (!val || val == _this.user_data['fcm_token']) {
                return;
            }
            var url = _this.service_data['_links']['user_update']['href'];
            var url_req = url.replace('##user_id##', _this.user_data['id']);
            var params = { fcm_token: val };
            _this.apiProv.patch(url_req, params)
                .then(function (data) {
                if (data['statusCode'] != '000') {
                    return;
                }
                // 保持データ更新
                _this.user_data['fcm_token'] = val;
                _this.comProv.setUser(_this.user_data);
            }).catch(function (error) {
                console.log('error', error);
            });
        });
    };
    MyApp.prototype.getDrawer = function () {
        var _this = this;
        this.apiProv.get(this.service_data['_links']['app_drawer_menus']['href'])
            .then(function (data) {
            if (data['statusCode'] != '000') {
                return;
            }
            for (var i = 0; i < data['data'].length; i++) {
                if (data['data'][i]['is_privated'] == 1) {
                    continue;
                }
                if (data['data'][i]['image_url']) {
                    data['data'][i]['image_url'] = data['data'][i]['image_url'].replace('fab ', 'fab-tenpo ');
                }
                _this.drawer_list.push(data['data'][i]);
            }
            localStorage.setItem('drawer_list', JSON.stringify(data['data']));
            _this.events.publish('drawer:set');
            if (_this.comProv.isPc()) {
                _this.chk_pc['chk_drawer'] = true;
                _this.goHomePc();
            }
            _this.chk_start['chk_drawer'] = true;
            _this.goHome();
        }).catch(function (error) {
            if (_this.comProv.isPc()) {
                _this.chk_pc['chk_drawer'] = true;
                _this.goHomePc();
            }
            _this.chk_start['chk_drawer'] = true;
            _this.goHome();
        });
    };
    MyApp.prototype.getPhotoCategory = function () {
        this.apiProv.get(this.service_data['_links']['photo_categories']['href'])
            .then(function (data) {
            if (data['statusCode'] != '000') {
                return;
            }
            localStorage.setItem('photo_category', JSON.stringify(data['data']));
        }).catch(function (error) {
        });
    };
    MyApp.prototype.getCouponCategory = function () {
        this.apiProv.get(this.service_data['_links']['coupon_categories']['href'])
            .then(function (data) {
            if (data['statusCode'] != '000') {
                return;
            }
            localStorage.setItem('coupon_category_list', JSON.stringify(data['data']));
        }).catch(function (error) {
        });
    };
    MyApp.prototype.getShopInfo = function () {
        var _this = this;
        this.apiProv.get(this.service_data['_links']['shop_info']['href'])
            .then(function (data) {
            if (data['statusCode'] != '000') {
                return;
            }
            _this.comProv.setBrandList(data['data']['brands']);
            //localStorage.setItem('brand_list', JSON.stringify(data['data']['brands']));
            localStorage.setItem('prefecture_list', JSON.stringify(data['data']['prefecture']));
            if (data['data']['tags']) {
                _this.comProv.setTag(data['data']['tags']);
                //localStorage.setItem('shop_tag_list', JSON.stringify(data['data']['tags']));
            }
            else {
                localStorage.removeItem('shop_tag_list');
            }
            if (data['data']['event_categories']) {
                localStorage.setItem('event_category_list', JSON.stringify(data['data']['event_categories']));
            }
            else {
                localStorage.removeItem('event_category_list');
            }
            _this.chk_start['shop_info'] = true;
            _this.goHome();
        }).catch(function (error) {
            _this.chk_start['shop_info'] = true;
            _this.goHome();
        });
    };
    MyApp.prototype.getCardData = function () {
        var _this = this;
        this.apiProv.get(this.service_data['_links']['app_membership_card']['href'])
            .then(function (data) {
            if (data['statusCode'] != '000') {
                _this.apiProv.detaError(data);
                return;
            }
            localStorage.setItem('card_data', JSON.stringify(data['data']));
        }).catch(function (error) {
        });
    };
    MyApp.prototype.getWebviewData = function () {
        var _this = this;
        this.apiProv.get(this.service_data['_links']['app_webviews']['href'])
            .then(function (data) {
            if (data['statusCode'] != '000') {
                _this.apiProv.detaError(data);
                return;
            }
            localStorage.setItem('webview_data', JSON.stringify(data['data']));
        }).catch(function (error) {
        });
    };
    MyApp.prototype.getProfileList = function () {
        var _this = this;
        this.apiProv.get(this.service_data['_links']['target_user_profiles']['href'])
            .then(function (data) {
            if (data['statusCode'] != '000') {
                _this.apiProv.detaError(data);
                return;
            }
            localStorage.setItem('profile_list', JSON.stringify(data['data']));
        }).catch(function (error) {
        });
    };
    MyApp.prototype.getRssList = function () {
        var _this = this;
        this.apiProv.get(this.service_data['_links']['rss_feeds']['href'])
            .then(function (data) {
            if (data['statusCode'] != '000') {
                _this.apiProv.detaError(data);
                return;
            }
            localStorage.setItem('rss_list', JSON.stringify(data['data']));
            _this.chk_start['chk_rss'] = true;
            _this.goHome();
        }).catch(function (error) {
        });
    };
    MyApp.prototype.goQRCodeUrl = function (barcode_text) {
        var chk = barcode_text.match(/(http|https):\/\/.+/);
        if (!chk) {
            var alert_1 = this.alertCtrl.create({
                message: '値がURLではありません。',
                cssClass: 'alert_common',
                enableBackdropDismiss: false,
                buttons: [
                    {
                        text: '閉じる',
                        role: 'cancel',
                        handler: function () {
                        }
                    },
                ]
            });
            alert_1.present();
            return;
        }
        this.comProv.setLink(barcode_text);
    };
    MyApp.prototype.goPage = function (page_data) {
        var data = {
            url: page_data['page_url'],
            target: page_data['page_target'],
            current_page: this.rootParams['current_page'],
            //current_page: this.current_page,
            category: 'ドロワーメニュー'
        };
        this.comProv.goPage(data, this.nav, this.gaProv);
    };
    MyApp.prototype.setPage = function (page_name) {
        this.nav.setRoot(page_name);
    };
    MyApp.prototype.goStore = function () {
        if (this.platform.is('android')) {
            window.ionic.postReview();
        }
        else if (this.platform.is('ios') && this.service_data['apple_id']) {
            var message = {
                action: 'Review',
                parameters: {
                    app_id: this.service_data['apple_id']
                }
            };
            window.webkit.messageHandlers.ionic.postMessage(message);
        }
    };
    MyApp.prototype.goError = function (message) {
        this.nav.setRoot('ErrorPage', { message: message });
    };
    MyApp.prototype.logout = function () {
        this.comProv.logout();
        this.is_login = this.comProv.isLogin();
        this.nav.setRoot('LoginPage');
    };
    MyApp.prototype.login = function () {
        this.nav.setRoot('LoginPage');
    };
    __decorate([
        ViewChild(Nav),
        __metadata("design:type", Nav)
    ], MyApp.prototype, "nav", void 0);
    MyApp = __decorate([
        Component({
            templateUrl: 'app.html',
            providers: [DatePipe]
        }),
        __metadata("design:paramtypes", [Platform,
            Events,
            IonicApp,
            ApiProvider,
            AnalyticsProvider,
            CommonProvider,
            Storage,
            FirebaseMessagingProvider,
            AlertController,
            TranslateService])
    ], MyApp);
    return MyApp;
}());
export { MyApp };
//# sourceMappingURL=app.component.js.map


// WEBPACK FOOTER //
// ./src/app/app.component.ts.pre-build-optimizer.js